import React from 'react';
import './Home.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faGithub, faInstagram, faLinkedinIn, faMedium, faTwitter } from '@fortawesome/free-brands-svg-icons';
import HomeImage from '../../images/SamratUpdate.jpg';
import SimpleParticlesBackground from '../ParticlesBackground/SimpleParticlesBackground';
const Home = () => {
    return (
        <>
            <div className="particles-bg">
                {/* <SimpleParticlesBackground /> */}
            </div>
            <section id="home" className="home section">
                <div className="container">
                    <div className="intro">
                        <img src={HomeImage} alt="profile" className="shadow-dark" />
                        <h1>S.M. SAMRAT</h1>
                        <p>Front End Developer</p>
                        <div className="social-links">
                            <a href="https://github.com/imsamrat" rel="noreferrer" target="_blank"><FontAwesomeIcon icon={faGithub} /></a>
                            <a href="https://www.linkedin.com/in/ims4mrat/" rel="noreferrer" target="_blank"><FontAwesomeIcon icon={faLinkedinIn} /></a>
                            <a href="https://www.facebook.com/ims4mrat" rel="noreferrer" target="_blank"><FontAwesomeIcon icon={faFacebookF} /></a>
                            <a href="https://www.instagram.com/ims4mrat" rel="noreferrer" target="_blank"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://twitter.com/ims4mrat" rel="noreferrer" target="_blank"><FontAwesomeIcon icon={faTwitter} /></a>
                            <a href="https://medium.com/@imsamrat24" rel="noreferrer" target="_blank"><FontAwesomeIcon icon={faMedium} /></a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Home;